<template>
  <div class="w-full bg-gray-100 h-screen">
    <div
      class="container flex items-center justify-center flex-1 h-full mx-auto text-center"
    >
      <div class="w-full max-w-lg">
        <h1 class="text-4xl">Oops!</h1>
        <h3 class="my-4">
          The {{ resource }} you are looking for is not here.
        </h3>
        <div class="mt-6">
          <router-link
            class="px-6 py-2 transition ease-in duration-200 uppercase rounded-full hover:bg-gray-800 hover:text-white border-2 border-gray-900 focus:outline-none"
            :to="{ name: 'Dashboard' }"
            >Back to the Home Page</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      required: true,
      default: "page",
    },
  },
}
</script>
